import React from 'react';
import './Rebook.css';

// Sidebar pages we haven't designed yet — an honest screen instead of a dead tap
const NotBuilt = ({ icon, title }) => (
  <div className="not-built">
    <div className="not-built-icon">{icon}</div>
    <h1>{title}</h1>
    <p>This page isn’t built yet. It’s next on the list once we design it together.</p>
  </div>
);

export default NotBuilt;
